<template>
  <b-navbar toggleable="md" type="dark">
    <b-navbar-brand>
      <router-link to="/"><img src="lecle_icon.png" alt="icon" /> Lecle Reviews</router-link>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" />

    <b-collapse id="nav-collapse" is-nav v-if="isLoggedIn">
      <b-navbar-nav>
        <b-nav-item>
          <router-link to="/rw-form" :exact="true">Review form</router-link>
        </b-nav-item>
        <b-nav-item>
          <router-link :to="{ name: 'Result' }" :exact="true">Review result</router-link>
        </b-nav-item>
        <b-nav-item v-if="isAdmin">
          <router-link to="/rw-session" :exact="true">Review Session</router-link>
        </b-nav-item>
        <b-nav-item v-if="isAdmin">
          <router-link to="/criteria">Criteria</router-link>
        </b-nav-item>
        <b-nav-item v-if="isAdmin">
          <router-link to="/users">User</router-link>
        </b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="!isLoggedIn">
          <router-link to="/login">Login</router-link>
        </b-nav-item>

        <b-nav-item v-if="isLoggedIn"> Hi, {{ user.name }} </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'NavBar',
  computed: {
    ...mapGetters('app', ['user', 'isLoggedIn', 'isAdmin']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors';
nav {
  background: $darkBlue;
  color: $white;

  padding: 1rem 3rem;

  a {
    color: $gray !important;
    font-size: 1.5rem;
    text-decoration: none;
  }

  .router-link-exact-active {
    border-bottom: 0.2rem solid $gray;
  }

  .nav-item:not(:last-child) {
    margin-right: 1rem;
  }

  .navbar-brand {
    a {
      font-size: 2rem;
      font-weight: bold;
    }

    display: flex;
    align-items: center;

    img {
      padding-bottom: 0.3rem;
    }

    @media (max-width: 360px) {
      img {
        width: 2rem;
      }
    }
  }
}
</style>
